//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
// import { useEffect } from "react";
import { shallowEqual,  useSelector } from "react-redux";

//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const book_cogantes_selector = (state) => state.vocabulary_cogantes;

export const useCognets = () => {
  const book_cogantes = useSelector(book_cogantes_selector, shallowEqual);
  return book_cogantes;
};
